import { constants } from '../../helpers';
import { DateRangeFlexSalesProps } from '../DateRangeFlexSales';
import ReportBusinessDateRangeFilter from '../ReportFilters/filters/BusinessDateRangeFilter';

type BusinessDateRangeFilterProps = Pick<DateRangeFlexSalesProps<Date>, 'spacing'> & {
  maxDaysBetween?: number;
  requiredIncomplete?: boolean;
};

const BusinessDateRangeFilter = (props: BusinessDateRangeFilterProps) => (
  <ReportBusinessDateRangeFilter {...props} maxDate={constants.reportGcsFilterRangeMaxDate} />
);

export default BusinessDateRangeFilter;
